// Long enough for the browser to fire beforeunload for the reload, short enough
// that a reload the user aborts (Stop, Esc, clicking a link) does not leave the
// guards disabled for edits made afterwards.
const DISCARD_WINDOW_MS = 1000;

let discardingUnsavedChanges = false;

// Lets the "Leave site?" guards stand down for a reload the user asked for as
// a way to throw their edits away.
export const isDiscardingUnsavedChanges = () => discardingUnsavedChanges;

export const reloadDiscardingUnsavedChanges = () => {
  discardingUnsavedChanges = true;
  setTimeout(() => {
    discardingUnsavedChanges = false;
  }, DISCARD_WINDOW_MS);
  window.location.reload();
};
